// OSINT Tools Configuration
// Add your API keys here when you obtain them

export const OSINT_CONFIG = {
  // Free APIs that require keys (optional upgrades)
  API_NINJAS_KEY: process.env.REACT_APP_API_NINJAS_KEY || '', // Free tier: 50k requests/month
  HUNTER_IO_KEY: process.env.REACT_APP_HUNTER_IO_KEY || '', // Free tier: 25 searches/month
  NUMVERIFY_KEY: process.env.REACT_APP_NUMVERIFY_KEY || '', // Free tier: 250 requests/month
  IPSTACK_KEY: process.env.REACT_APP_IPSTACK_KEY || '', // Free tier: 10k requests/month
  IPGEOLOCATION_KEY: process.env.REACT_APP_IPGEOLOCATION_KEY || '', // Free tier: 30k requests/month
  
  // Social Media OSINT APIs
  SOCIAL_SEARCHER_KEY: process.env.REACT_APP_SOCIAL_SEARCHER_KEY || '', // Free tier: 100 searches/month
  PIPL_KEY: process.env.REACT_APP_PIPL_KEY || '', // Premium people search
  SPOKEO_KEY: process.env.REACT_APP_SPOKEO_KEY || '', // People search and background checks
  BEEN_VERIFIED_KEY: process.env.REACT_APP_BEEN_VERIFIED_KEY || '', // Background checks
  TWITTER_BEARER_TOKEN: process.env.REACT_APP_TWITTER_BEARER_TOKEN || '', // Twitter API v2
  FACEBOOK_ACCESS_TOKEN: process.env.REACT_APP_FACEBOOK_ACCESS_TOKEN || '', // Facebook Graph API
  LINKEDIN_ACCESS_TOKEN: process.env.REACT_APP_LINKEDIN_ACCESS_TOKEN || '', // LinkedIn API
  TIKTOK_ACCESS_TOKEN: process.env.REACT_APP_TIKTOK_ACCESS_TOKEN || '', // TikTok Research API
  
  // Premium APIs (optional)
  SHODAN_KEY: process.env.REACT_APP_SHODAN_KEY || '',
  VIRUSTOTAL_KEY: process.env.REACT_APP_VIRUSTOTAL_KEY || '',
  URLSCAN_KEY: process.env.REACT_APP_URLSCAN_KEY || '',
  SECURITYTRAILS_KEY: process.env.REACT_APP_SECURITYTRAILS_KEY || '',
  
  // Free service endpoints
  ENDPOINTS: {
    IP_API: 'http://ip-api.com/json',
    FREE_IP_API: 'https://freeipapi.com/api/json',
    IPAPI_CO: 'https://ipapi.co',
    GOOGLE_DNS: 'https://dns.google/resolve',
    CLOUDFLARE_DNS: 'https://cloudflare-dns.com/dns-query',
    DOMAINS_DB: 'https://api.domainsdb.info/v1/domains/search',
    
    // Social Media Endpoints
    SOCIAL_SEARCHER: 'https://api.social-searcher.com/v2',
    PIPL_API: 'https://api.pipl.com/search/v5',
    TWITTER_API: 'https://api.twitter.com/2',
    FACEBOOK_GRAPH: 'https://graph.facebook.com/v18.0',
    LINKEDIN_API: 'https://api.linkedin.com/v2',
    TIKTOK_RESEARCH: 'https://open.tiktokapis.com/v2/research',
    
    // Free username enumeration services
    SHERLOCK_API: 'https://sherlock-project.github.io', // Note: This is a tool, not API
    WHATSMYNAME: 'https://whatsmyname.app/api',
    TRUE_PEOPLE_SEARCH: 'https://www.truepeoplesearch.com', // Scraping required
    
    // Social platform direct APIs (free tiers available)
    INSTAGRAM_BASIC: 'https://graph.instagram.com',
    YOUTUBE_API: 'https://www.googleapis.com/youtube/v3'
  },
  
  // Social Media Tools (Open Source / Free Tools)
  SOCIAL_TOOLS: {
    // These are tools to integrate or reference, not direct APIs
    SHERLOCK: 'github.com/sherlock-project/sherlock', // Username search across 400+ sites
    WHATSMYNAME: 'github.com/WebBreacher/WhatsMyName', // Username enumeration
    SOCIAL_MAPPER: 'github.com/Greenwolf/social_mapper', // Facial recognition across social media
    TWINT: 'github.com/twintproject/twint', // Twitter scraping without API
    INSTALOADER: 'github.com/instaloader/instaloader', // Instagram data extraction
    OSINT_SPY: 'github.com/SharadKumar97/OSINT-SPY', // Multi-platform OSINT
    MAIGRET: 'github.com/soxoj/maigret', // Username investigation tool
    HOLEHE: 'github.com/megadose/holehe', // Email to social media account finder
    SOCIALSCAN: 'github.com/iojw/socialscan', // Username/email availability checker
  },
  
  // Rate limiting settings
  RATE_LIMITS: {
    IP_API: 45, // requests per minute
    FREE_IP_API: 60, // requests per minute
    GOOGLE_DNS: 1000, // no official limit
    CLOUDFLARE_DNS: 1000, // no official limit
    SOCIAL_SEARCHER: 100, // requests per month (free tier)
    TWITTER_API: 300, // requests per 15 minutes
    FACEBOOK_GRAPH: 200, // requests per hour (varies)
    LINKEDIN_API: 500, // requests per day
    INSTAGRAM_BASIC: 200 // requests per hour
  },

  // Feature toggles
  FEATURES: {
    ENABLE_PHONE_ANALYSIS: true,
    ENABLE_EMAIL_ANALYSIS: true,
    ENABLE_URL_ANALYSIS: true,
    ENABLE_DOMAIN_ANALYSIS: true,
    ENABLE_IP_ANALYSIS: true,
    ENABLE_SOCIAL_SEARCH: true,
    ENABLE_USERNAME_ENUM: true,
    ENABLE_PEOPLE_SEARCH: true,
    ENABLE_BACKGROUND_CHECK: true,
    ENABLE_CACHING: true,
    CACHE_DURATION: 300000 // 5 minutes in milliseconds
  },

  // Social Media Platform Mappings
  SOCIAL_PLATFORMS: {
    FACEBOOK: { name: 'Facebook', url: 'facebook.com', api_available: true },
    INSTAGRAM: { name: 'Instagram', url: 'instagram.com', api_available: true },
    TWITTER: { name: 'X (Twitter)', url: 'x.com', api_available: true, legacy_url: 'twitter.com' },
    LINKEDIN: { name: 'LinkedIn', url: 'linkedin.com', api_available: true },
    TIKTOK: { name: 'TikTok', url: 'tiktok.com', api_available: true },
    YOUTUBE: { name: 'YouTube', url: 'youtube.com', api_available: true },
    SNAPCHAT: { name: 'Snapchat', url: 'snapchat.com', api_available: false },
    PINTEREST: { name: 'Pinterest', url: 'pinterest.com', api_available: true },
    REDDIT: { name: 'Reddit', url: 'reddit.com', api_available: true },
    DISCORD: { name: 'Discord', url: 'discord.com', api_available: false },
    TELEGRAM: { name: 'Telegram', url: 't.me', api_available: true },
    WHATSAPP: { name: 'WhatsApp', url: 'whatsapp.com', api_available: false },
  }
};

// Helper function to check if API key is available
export const hasApiKey = (service) => {
  return OSINT_CONFIG[service] && OSINT_CONFIG[service].length > 0;
};

// Helper function to get rate limit for a service
export const getRateLimit = (service) => {
  return OSINT_CONFIG.RATE_LIMITS[service] || 60;
};

// Helper function to get social platforms where user might have accounts
export const getSocialPlatforms = () => {
  return OSINT_CONFIG.SOCIAL_PLATFORMS;
};

// Helper function to check if social media features are enabled
export const isSocialFeatureEnabled = (feature) => {
  const socialFeatures = [
    'ENABLE_SOCIAL_SEARCH',
    'ENABLE_USERNAME_ENUM', 
    'ENABLE_PEOPLE_SEARCH',
    'ENABLE_BACKGROUND_CHECK'
  ];
  return socialFeatures.includes(feature) && OSINT_CONFIG.FEATURES[feature];
}; 